import React from "react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied() {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            <div style={styles.content}>

                {/* Text */}
                <h1 style={styles.title}>Access Denied</h1>
                <p style={styles.subtitle}>
                    The page you’re trying to access has restricted access.
                    <br />
                    Please contact your system administrator.
                </p>

                {/* Action */}
                <button style={styles.button} onClick={() => navigate(-1)}>
                    Go back
                </button>
            </div>
        </div>
    );
}


const styles = {
    page: {
        minHeight: "50vh",
        backgroundColor: "#f7f9fc",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    },

    content: {
        textAlign: "center",
        padding: "40px 24px",
        maxWidth: "720px",
    },

    illustrationWrapper: {
        position: "relative",
        marginBottom: "32px",
    },

    bigCode: {
        fontSize: "140px",
        fontWeight: "800",
        color: "#e6ebf2",
        letterSpacing: "12px",
        userSelect: "none",
    },

    illustration: {
        position: "absolute",
        inset: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    circle: {
        width: "160px",
        height: "160px",
        borderRadius: "50%",
        background: "linear-gradient(135deg, #e3ebff, #f5f8ff)",
        position: "absolute",
    },

    characterLeft: {
        width: "40px",
        height: "80px",
        backgroundColor: "#4c6ef5",
        borderRadius: "20px",
        position: "absolute",
        left: "calc(50% - 90px)",
        bottom: "10px",
    },

    characterRight: {
        width: "40px",
        height: "100px",
        backgroundColor: "#15aabf",
        borderRadius: "20px",
        position: "absolute",
        right: "calc(50% - 90px)",
        bottom: "10px",
    },

    title: {
        fontSize: "28px",
        fontWeight: "700",
        color: "var(--text-dark)",
        marginBottom: "12px",
    },

    subtitle: {
        fontSize: "16px",
        color: "#6b7280",
        lineHeight: "1.6",
        marginBottom: "32px",
    },

    button: {
        backgroundColor: "var(--color-primary)",
        color: "#ffffff",
        border: "none",
        borderRadius: "999px",
        padding: "12px 32px",
        fontSize: "15px",
        fontWeight: "600",
        cursor: "pointer",
    },
};
